import { motion } from "framer-motion";
import { SectionHeading } from "./Story";
import { imgSrc, imgStyle } from "@/lib/img";

export const Gallery = ({ images = [] }) => (
  <section id="gallery" className="py-20 sm:py-28 lg:py-32 bg-[var(--surface)]" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <SectionHeading script="moments" title="Our Gallery" testid="gallery-heading" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {images.map((src, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.94 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
            className={`overflow-hidden rounded-lg group ${i % 3 === 0 ? "row-span-2" : ""}`}
            data-testid={`gallery-image-${i}`}
          >
            <img
              src={imgSrc(src)}
              style={imgStyle(src)}
              alt={`Gallery ${i + 1}`}
              loading="lazy"
              className={`w-full object-cover ${i % 3 === 0 ? "h-full min-h-[320px]" : "h-40 sm:h-56"}`}
            />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
